import commonService from "./common-service";

class MasterService {
  async getMasterData(payor, group, unique) {
    try {
      const response = await commonService.getFromServer(
        "EOM/FacilityMaster?payor=" + payor + "&group=" + group + "&unique" + unique,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async createData(params) {
    try {
      let response =  await commonService.postToServer(
        "EOM/FacilityMaster",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async uploadDocument(params) {
    try {
      const response = await commonService.postToServer(
        "EOM/FacilityMaster/Upload",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error uploading document");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async downloadDocument(params) {
    try {
       await commonService.downloadFromServer(
        "EOM/FacilityMaster/Download",
        {'fileName':'AllFacilities.xlsx'}
      );
      
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async updateData(params) {
    try {
      let response =  await commonService.updateToServer(
        "EOM/FacilityMaster/"+params?.id,
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getData(id) {
    try {
      const response = await commonService.getFromServer(
        "EOM/FacilityMaster/" + id,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.msg.error);
    }
  }

  async deleteData(id) {
    try {
      const response = await commonService.deleteToServer(
        "EOM/FacilityMaster/" + id,
        {}
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error deleting data");
      }
    } catch (e) {
      throw new Error("Error deleting data");
    }
  }

  async getPayors() {
    try {
      const response = await commonService.getFromServer(
        "EOM/FacilityMaster/Payors",
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error(
          "Error retrieving payors. Please contact administrator."
        );
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getGroupCodes(payor) {
    try {
      payor = payor ? payor : "";
      const response = await commonService.getFromServer(
        "EOM/FacilityMaster/Groups?payor=" + payor 
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async getUniqueCodes(payor, group) {
    try {
      const response = await commonService.getFromServer(
        "EOM/FacilityMaster/Uniques?payor=" + payor + "&group=" + group
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }


}
export default new MasterService();
